import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import DownSvg from './styledArrowDown'; // Changed to import default

const ArrowDown = ({ width = 10, height = 5 }) => (
  <DownSvg
    width={width}
    height={height}
    viewBox="0 0 10 5"
    fill="none"
  >
    <path d="M0 0L5 5L10 0H0Z" />
  </DownSvg>
);

ArrowDown.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default memo(ArrowDown);
